import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { CreateRoleRequestModel } from "../manage-roles/role-admin-add-role/CreateRoleRequestModel";
import { EditRoleRequestModel } from "../manage-roles/role-admin-edit-role/EditRoleRequestModel";
import { ChangeIntsModel } from "../manage-school-container/ChangeIntsModel";
import { CreateUserRequestModel } from "../user-administration/shared/CreateUserRequestModel";
import { EmailRequestModel } from "../user-administration/shared/EmailRequestModel";
import { UpdateUserRequestModel } from "../user-administration/shared/UpdateUserRequestModel";
import { UserGroupRequestModel } from "../user-administration/shared/UserGroupRequestModel";
import { RolesToChangeModel } from "../user-group-administration/user-group-role-table/RolesToChangeModel";
import { UsersToChangeModel } from "../user-group-administration/user-group-user-table/UsersToChangeModel";
import { ContainersToChangeModel } from "../user-group-assignment/user-group-assign-container/ContainersToChangeModel";
import { SchoolsToChangeModel } from "../user-group-assignment/user-group-assign-school/SchoolsToChangeModel";
import { SchoolGroupModifyRequest } from "./SchoolGroupModifyRequest";
import { StaffSimpleInsertRequest } from "./StaffSimpleInsertRequest";
import { StringIntRequest } from "./StringIntRequest";
import { StringRequest } from "./StringRequest";
import { UserGroupInsertRequest } from "./UserGroupInsertRequest";
import { UserGroupUpdateRequest } from "./UserGroupUpdateRequest";
import { UserResetPasswordRequest } from "./UserResetPasswordRequest";
import { IntListRequest } from "./IntListRequest";

@Injectable()
export class SysAdminService {
	constructor(private httpclientService: HttpclientService) {}

	RoleGet(roleID) {
		var postResult$ = new Subject();
		var url = "Role/RoleGet?RoleID=" + roleID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleApplicationGetList(roleID, SchoolID, ApplicationID) {
		var postResult$ = new Subject();
		var url = "Role/RoleApplicationGetList?RoleID=" + roleID + "&SchoolID=" + SchoolID + "&ApplicationID=" + ApplicationID;

		var promise$ = this.httpclientService.post(url, null);

		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGetList(SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGetList?SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserLevelGetList() {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserLevelGetList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffGetList(SelectActiveStaff, SearchCriteria, LastName, FirstName, IntParm, SchoolID, InstructorOnly) {
		var postResult$ = new Subject();
		var url =
			"SysAdmin/StaffGetList?SelectActiveStaff=" +
			SelectActiveStaff +
			"&SearchCriteria=" +
			SearchCriteria +
			"&LastName=" +
			LastName +
			"&FirstName=" +
			FirstName +
			"&IntParm=" +
			IntParm +
			"&SchoolID=" +
			SchoolID +
			"&InstructorOnly=" +
			InstructorOnly;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupGetList(parms: UserGroupRequestModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupGetList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadRoleList(UserLevelID, SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleGetList?UserLevelID=" + UserLevelID + "&SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailGetList(parms: EmailRequestModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/EmailGetList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CreateUser(parms: CreateUserRequestModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/CreateUser";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateUser(parms: UpdateUserRequestModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UpdateUser";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersIsNameUsed(parms: StringIntRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersIsNameUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersSetActive(UserID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersSetActive?UserID=" + UserID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersDelete(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersDelete?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersSetLocked(UserID, Locked, c_personID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersSetLocked?UserID=" + UserID + "&Locked=" + Locked + "&c_personID=" + c_personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupGetListBySchoolID(SchoolID, UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupGetListBySchoolID?SchoolID=" + SchoolID + "&UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleGetListByUserGroup(UserGroupID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleGetListByUserGroup?UserGroupID=" + UserGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersGetByUserGroup(UserGroupID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersGetByUserGroup?UserGroupID=" + UserGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupCodeInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/GroupCodeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GroupDescInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/GroupDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupInsert(parms: UserGroupInsertRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupUpdate(parms: UserGroupUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupToggle(UserGroupID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupToggle?UserGroupID=" + UserGroupID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupAddRoles(parms: RolesToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupAddRoles";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupRemoveRoles(parms: RolesToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupRemoveRoles";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGetListByLevel(SchoolID, Active, UserLevelID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGetListByLevel?SchoolID=" + SchoolID + "&Active=" + Active + "&UserLevelID=" + UserLevelID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupAddUsers(parms: UsersToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupAddUsers";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupRemoveUsers(parms: UsersToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupRemoveUsers";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupGetContainers(UserGroupID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupGetContainers?UserGroupID=" + UserGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupAddContainers(parms: ContainersToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupAddContainers";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupRemoveContainers(parms: ContainersToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupRemoveContainers";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupAddSchools(parms: SchoolsToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupAddSchools";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupRemoveSchools(parms: SchoolsToChangeModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupRemoveSchools";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupGetAllContainers(Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupGetAllContainers?Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupGetSchools(UserGroupID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupGetSchools?UserGroupID=" + UserGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupCodeInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupCodeInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupDescInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupModify(parms: SchoolGroupModifyRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupModify";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupActivate(SchoolGroupID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupActivate?SchoolGroupID=" + SchoolGroupID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupGetSchools(SchoolGroupID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupGetSchools?SchoolGroupID=" + SchoolGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupAddSchools(parms: ChangeIntsModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupAddSchools";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupRemoveSchools(parms: ChangeIntsModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupRemoveSchools";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupGetUserGroups(SchoolGroupID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupGetUserGroups?SchoolGroupID=" + SchoolGroupID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupAddUserGroups(parms: ChangeIntsModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupAddUserGroups";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolGroupRemoveUserGroups(parms: ChangeIntsModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SchoolGroupRemoveUserGroups";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleSelectEditList(SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleSelectEditList?SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetReportsForUser(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/GetReportsForUser?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CreateRole(parms: CreateRoleRequestModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/CreateRole";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EditRole(parms: EditRoleRequestModel) {
		var postResult$ = new Subject();
		var url = "SysAdmin/EditRole";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleNameUsed(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleNameUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleDescUsed(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleDescUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleDelete(RoleID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleDelete?RoleID=" + RoleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleToggle(RoleID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleToggle?RoleID=" + RoleID + "&ChangeTo=" + ChangeTo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleSelect(RoleID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleSelect?RoleID=" + RoleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailInUse(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/EmailInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RemoveSchoolLevel(RoleID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RemoveSchoolLevel?RoleID=" + RoleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetReportsForRoleSchool(RoleID, SchoolID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/GetReportsForRoleSchool?RoleID=" + RoleID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetPasswordPreferences() {
		var postResult$ = new Subject();
		var url = "SysAdmin/GetPasswordPreferences?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminStaffSelectList(SchoolID, ActiveOnly, UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminStaffSelectList?SchoolID=" + SchoolID + "&ActiveOnly=" + ActiveOnly + "&UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleSimpleInfoGetList(UserLevelID, SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleSimpleInfoGetList?UserLevelID=" + UserLevelID + "&SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleWithPagesGetList(UserLevelID, SchoolID, Active) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleWithPagesGetList?UserLevelID=" + UserLevelID + "&SchoolID=" + SchoolID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupSimpleInfoGetList(UserLevelID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupSimpleInfoGetList?UserLevelID=" + UserLevelID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminEmailSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminEmailSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminUserDetailsSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminUserDetailsSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminUserSchoolsSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminUserSchoolsSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminUserUserGroupsSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminUserUserGroupsSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminUserEmailSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminUserEmailSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminSchoolRoleSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminSchoolRoleSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserResetMFA(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserResetMFA?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserResetPassword(parms: UserResetPasswordRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserResetPassword";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffIDExists(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/StaffIDExists";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffSimpleInsert(parms: StaffSimpleInsertRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/StaffSimpleInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminUserModifyPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminUserModifyPreferenceSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersToggleMFA(UserID, ChangeTo, ResetRegistration) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersToggleMFA?UserID=" + UserID + "&ChangeTo=" + ChangeTo + "&ResetRegistration=" + ResetRegistration;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UsersToggleAllMFA(SchoolID, ChangeTo, ResetRegistration) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UsersToggleAllMFA?SchoolID=" + SchoolID + "&ChangeTo=" + ChangeTo + "&ResetRegistration=" + ResetRegistration;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SysAdminEmailSelectListBySchools(parms: IntListRequest) {
		var postResult$ = new Subject();
		var url = "SysAdmin/SysAdminEmailSelectListBySchools";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PasswordInstructionSelect() {
		var postResult$ = new Subject();
		var url = "api/token/PasswordInstructionSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserDebugInfoSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserDebugInfoSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserGroupPreferencesSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserGroupPreferencesSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoleExportUser(RoleID) {
		var postResult$ = new Subject();
		var url = "SysAdmin/RoleExportUser?RoleID=" + RoleID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UserAdminPreferenceSelect() {
		var postResult$ = new Subject();
		var url = "SysAdmin/UserAdminPreferenceSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
